var $2d5bf08df4621572$exports = {};
/** allows us to send an email */ const $2d5bf08df4621572$var$form = document.querySelector("form");
const $2d5bf08df4621572$var$fullname = document.getElementById("name");
const $2d5bf08df4621572$var$email = document.getElementById("email");
const $2d5bf08df4621572$var$msg = document.getElementById("message");
function $2d5bf08df4621572$var$sendEmail() {
    const bodyMessage = `Full Name: ${$2d5bf08df4621572$var$fullname.value}<br><br> Email: ${$2d5bf08df4621572$var$email.value}<br><br> Message: ${$2d5bf08df4621572$var$msg.value}`;
    Email.send({
        SecureToken: "77eac908-5b7f-49a9-8f5b-024ff264d8e8",
        To: 'govan.dibotelo@gmail.com',
        From: 'govan.dibotelo@gmail.com',
        Subject: "Customer enquiry",
        Body: bodyMessage
    }).then((message)=>{
        if (message == "OK") Swal.fire({
            position: "center",
            icon: "success",
            title: "Message sent successfully",
            showConfirmButton: false
        });
        else Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Couldn't send message, something went wrong!"
        });
    });
}
function $2d5bf08df4621572$var$checkInputs() {
    const items = document.querySelectorAll(".input-form");
    for (const item of items){
        if (item.value == "") {
            item.classList.add("error");
            item.parentElement.classList.add("error");
        }
        if (items[1].value != "") $2d5bf08df4621572$var$checkEmail();
        items[1].addEventListener("keyup", ()=>{
            $2d5bf08df4621572$var$checkEmail();
        });
        item.addEventListener("keyup", ()=>{
            if (item.value != "") {
                item.classList.remove("error");
                item.parentElement.classList.remove("error");
            } else {
                item.classList.add("error");
                item.parentElement.classList.add("error");
            }
        });
    }
}
function $2d5bf08df4621572$var$checkEmail() {
    const emailRegex = /^([a-z\d\.-]+)@([a-z\d\-]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/;
    const errorTxtEmail = document.querySelector(".error-txt.email");
    if (!$2d5bf08df4621572$var$email.value.match(emailRegex)) {
        $2d5bf08df4621572$var$email.classList.add("error");
        $2d5bf08df4621572$var$email.parentElement.classList.add("error");
        if ($2d5bf08df4621572$var$email.value != "") errorTxtEmail.innerText = "*Enter a valid email address";
        else errorTxtEmail.innerText = "*Email cannot be blank";
    } else {
        $2d5bf08df4621572$var$email.classList.remove("error");
        $2d5bf08df4621572$var$email.parentElement.classList.remove("error");
    }
}
$2d5bf08df4621572$var$form.addEventListener("submit", (e)=>{
    e.preventDefault();
    $2d5bf08df4621572$var$checkInputs();
    if (!$2d5bf08df4621572$var$fullname.classList.contains("error") && !$2d5bf08df4621572$var$email.classList.contains("error") && !$2d5bf08df4621572$var$msg.classList.contains("error")) {
        $2d5bf08df4621572$var$sendEmail();
        $2d5bf08df4621572$var$form.reset();
        return false;
    }
});


//# sourceMappingURL=contact.2724156b.js.map
